module.exports = __webpack_public_path__ + "images/home/depoimento3-402eb37b4e5c80a1da26c10e70394e6e0a40a7d8.png";